export class StorageKeys {
    public static readonly NavBarSelectedOrganization: string = 'navbar_selectedOrganization';
    public static readonly NavBarSelectedTeamId: string = 'navbar_selectedTeamId';
}

export class Roles {
    public static readonly User: string = 'user';
    public static readonly Manager: string = 'manager';
    public static readonly OrgAdmin: string = 'organizationAdmin';
    public static readonly PonderaAssociate: string = 'ponderaAssociate';
    public static readonly SiteAdmin: string = 'siteAdmin';
    public static readonly SuperAdmin: string = 'superAdmin';
}


// WEBPACK FOOTER //
// ./src/stores/Constants.tsx